<template>
  <div class="col-12 mt-5 align-items-center d-flex flex-column">
    <h4 class="fs-8 fw-bold">Third Strike Sentencing</h4>
    <table class="bordered">
      <thead>
        <tr>
          <th class="w-25"></th>
        <th class="w-25" v-if="charge?.newExposureObject?.triad[0] !== 0">Lower Term</th>
        <th class="w-25" v-if="charge?.newExposureObject?.triad[1] !== 0">Middle Term</th>
        <th class="w-25" v-if="charge?.newExposureObject?.triad[2] !== 0">Upper Term</th>
        </tr>
        
      </thead>
      <tbody>
        <tr class="w-100">
          <td class="fw-bold w-25">Option 1</td>
          <td
            class="align-text-center"
            :class="
              charge?.newExposureObject?.dotsonOptions?.option1Triad[0] >=
                charge?.newExposureObject?.dotsonOptions?.option3Triad[0] &&
              charge?.newExposureObject?.dotsonOptions?.option1Triad[0] >= 9000
                ? 'active'
                : ''
            "
            v-if="charge?.newExposureObject?.dotsonOptions?.option1Triad[0] > 0"
          >
            {{ convertDays(charge?.newExposureObject?.dotsonOptions?.option1Triad[0]) }} -
            Life
          </td>
          <td
            class="align-text-center"
            :class="
              charge?.newExposureObject?.dotsonOptions?.option1Triad[1] >=
                charge?.newExposureObject?.dotsonOptions?.option3Triad[1] &&
              charge?.newExposureObject?.dotsonOptions?.option1Triad[1] >= 9000
                ? 'active'
                : ''
            "
            v-if="charge?.newExposureObject?.dotsonOptions?.option1Triad[1] > 0"
          >
            {{ convertDays(charge?.newExposureObject?.dotsonOptions?.option1Triad[1]) }} -
            Life
          </td>
          <td
            class="align-text-center"
            :class="
              charge?.newExposureObject?.dotsonOptions?.option1Triad[2] >=
                charge?.newExposureObject?.dotsonOptions?.option3Triad[2] &&
              charge?.newExposureObject?.dotsonOptions?.option1Triad[2] >= 9000
                ? 'active'
                : ''
            "
            v-if="charge?.newExposureObject?.dotsonOptions?.option1Triad[2] > 0"
          >
            {{ convertDays(charge?.newExposureObject?.dotsonOptions?.option1Triad[2]) }} -
            Life
          </td>
        </tr>
        <tr class="w-100">
          <td class="fw-bold w-25">Option 2</td>
          <td
            class="align-text-center"
            :class="
              charge?.newExposureObject?.dotsonOptions?.option1Triad[0] <= 9000 &&
              charge?.newExposureObject?.dotsonOptions?.option3Triad[0] <= 9000
                ? 'active'
                : ''
            "
            v-if="charge?.newExposureObject?.dotsonOptions?.option1Triad[0] > 0"
          >
            25y - Life
          </td>
          <td
            class="align-text-center"
            :class="
              charge?.newExposureObject?.dotsonOptions?.option1Triad[1] <= 9000 &&
              charge?.newExposureObject?.dotsonOptions?.option3Triad[1] <= 9000
                ? 'active'
                : ''
            "
            v-if="charge?.newExposureObject?.dotsonOptions?.option1Triad[1] > 0"
          >
            25y - Life
          </td>
          <td
            class="align-text-center"
            :class="
              charge?.newExposureObject?.dotsonOptions?.option1Triad[2] <= 9000 &&
              charge?.newExposureObject?.dotsonOptions?.option3Triad[2] <= 9000
                ? 'active'
                : ''
            "
            v-if="charge?.newExposureObject?.dotsonOptions?.option1Triad[2] > 0"
          >
            25y - Life
          </td>
        </tr>
        <tr class="w-100">
          <td class="fw-bold w-25">Option 3</td>
          <td
            class="align-text-center"
            :class="
              charge?.newExposureObject?.dotsonOptions?.option3Triad[0] >=
                charge?.newExposureObject?.dotsonOptions?.option1Triad[0] &&
              charge?.newExposureObject?.dotsonOptions?.option3Triad[0] >= 9000
                ? 'active'
                : ''
            "
            v-if="charge?.newExposureObject?.dotsonOptions?.option3Triad[0] > 0"
          >
            {{ convertDays(charge?.newExposureObject?.dotsonOptions?.option3Triad[0]) }} -
            Life
          </td>
          <td
            class="align-text-center"
            :class="
              charge?.newExposureObject?.dotsonOptions?.option3Triad[1] >=
                charge?.newExposureObject?.dotsonOptions?.option1Triad[1] &&
              charge?.newExposureObject?.dotsonOptions?.option3Triad[1] >= 9000
                ? 'active'
                : ''
            "
            v-if="charge?.newExposureObject?.dotsonOptions?.option3Triad[1] > 0"
          >
            {{ convertDays(charge?.newExposureObject?.dotsonOptions?.option3Triad[1]) }} -
            Life
          </td>
          <td
            class="align-text-center"
            :class="
              charge?.newExposureObject?.dotsonOptions?.option3Triad[2] >=
                charge?.newExposureObject?.dotsonOptions?.option1Triad[2] &&
              charge?.newExposureObject?.dotsonOptions?.option3Triad[2] >= 9000
                ? 'active'
                : ''
            "
            v-if="charge?.newExposureObject?.dotsonOptions?.option3Triad[2] > 0"
          >
            {{ convertDays(charge?.newExposureObject?.dotsonOptions?.option3Triad[2]) }} -
            Life
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import SC from "../../components/utils/sharedComponent.vue";
export default {
  name: "DotsonTable",
  data() {
    return {
      charge: this.chg,
    };
  },
  props: ["chg"],
  methods: {
    convertDays(days) {
      let expo = SC.convertExpoDaysToString(days);
      // console.log(expo);
      return expo;
    },
  },
};
</script>
<style scoped>
table {
  border: 2px solid var(--primary-font) !important;
}
td {
  text-align: center;
  padding: 10px;
  border: 1px solid var(--primary-font);
}
th {
  text-align: center;
  border: 1px solid var(--primary-font) !important;
}
</style>
